import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { UserGroupApi } from 'api';
import { IUserGroup } from 'types';

function useGet(id: number) {
  return useAuthQuery(
    getQueryKeys([KEY]).detail(id),
    () => UserGroupApi.get(id),
    {
      select: (data) => data.data as IUserGroup,
      enabled: !!id,
    },
  );
}

export default useGet;
